import { render, staticRenderFns } from "./QuestionBuilder.vue?vue&type=template&id=74ae7a38&scoped=true&"
import script from "./QuestionBuilder.vue?vue&type=script&lang=js&"
export * from "./QuestionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBuilder.vue?vue&type=style&index=0&id=74ae7a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae7a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ae7a38')) {
      api.createRecord('74ae7a38', component.options)
    } else {
      api.reload('74ae7a38', component.options)
    }
    module.hot.accept("./QuestionBuilder.vue?vue&type=template&id=74ae7a38&scoped=true&", function () {
      api.rerender('74ae7a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Survey/QuestionBuilder.vue"
export default component.exports